import { ActionTree } from 'vuex';
import { IDeleteResourceState } from '@/content-library/delete-resource/store/delete-resource.types';
import {
  EDeleteResourceAction,
  EDeleteResourceMutation,
  state as defaultState,
} from '@/content-library/delete-resource/store/delete-resource.constants';
import { RootState } from '@/store/store';
import { ResourceService } from '@/api/resources/services/resource.service';

export const actions: ActionTree<IDeleteResourceState, RootState> = {
  async [EDeleteResourceAction.Delete]({ commit, dispatch }, id: string) {
    commit(EDeleteResourceMutation.SetDeleted, false);
    commit(EDeleteResourceMutation.SetDeleting, false);
    try {
      await ResourceService.delete(id);
      dispatch(EDeleteResourceAction.DeleteSuccess);
    } catch (error) {
      dispatch(EDeleteResourceAction.DeleteFailed);
    }
  },
  [EDeleteResourceAction.DeleteSuccess]({ commit }) {
    commit(EDeleteResourceMutation.SetDeleting, false);
    commit(EDeleteResourceMutation.SetDeleted, true);
  },
  [EDeleteResourceAction.DeleteFailed]({ commit }) {
    commit(EDeleteResourceMutation.SetDeleting, false);
    commit(EDeleteResourceMutation.SetDeleted, false);
  },
  [EDeleteResourceAction.Reset]({ commit }) {
    commit(EDeleteResourceMutation.SetState, { ...defaultState });
  },
};
